export enum MetaverseId {
    AFFILITY = 1,
    KABUTOCHO = 2,
};